import axios from "axios";
import { useEffect, useState } from "react";
import "./MentorAvailability.css";

// const BASE_URL = "http://localhost:8000";
const BASE_URL = "https://idealpursuits.co.in/api";

function MentorAvailability({ userData }) {
    const [dates, setDates] = useState([]);
    const [selectedDates, setSelectedDates] = useState([]);
    const [selectedTimeIds, setSelectedTimeIds] = useState([]);
    const [timeInputs, setTimeInputs] = useState({});
    const [bulkTime, setBulkTime] = useState("");

    useEffect(() => {
        const fetchDates = async () => {
            try {
                const response = await axios.post(`${BASE_URL}/mentor/getMentorDates.php`, {
                    mentorId: userData.mentorId,
                });
                let fetchedDates = response.data;

                // Get current date in IST
                const now = new Date();
                const istOffset = 5.5 * 60 * 60 * 1000; // IST is UTC +5:30
                const nowIST = new Date(now.getTime() + istOffset);

                // Calculate the date for the day after tomorrow
                const tomorrow = new Date(nowIST);
                tomorrow.setDate(tomorrow.getDate() + 1);

                // Format to YYYY-MM-DD
                const tomorrowDate = tomorrow.toISOString().split("T")[0];

                // Filter dates starting from the day after tomorrow
                fetchedDates = fetchedDates.filter(dateObj => dateObj.date >= tomorrowDate);

                if (fetchedDates.length < 30) {
                    await axios.post(`${BASE_URL}/mentor/saveMentorDates.php`, {
                        mentorId: userData.mentorId,
                        dates: generateDefaultDates(fetchedDates),
                    });
                    const newResponse = await axios.post(`${BASE_URL}/mentor/getMentorDates.php`, {
                        mentorId: userData.mentorId,
                    });

                    // Get current date in IST
                    const now = new Date();
                    const istOffset = 5.5 * 60 * 60 * 1000; // IST is UTC +5:30
                    const nowIST = new Date(now.getTime() + istOffset);

                    // Calculate the date for the day after tomorrow
                    const tomorrow = new Date(nowIST);
                    tomorrow.setDate(tomorrow.getDate() + 1);

                    // Format to YYYY-MM-DD
                    const tomorrowDate = tomorrow.toISOString().split("T")[0];

                    // Filter dates starting from the day after tomorrow
                    fetchedDates = newResponse.data.filter(dateObj => dateObj.date >= tomorrowDate);
                }

                setDates(fetchedDates);
            } catch (error) {
                console.error("Error fetching dates:", error);
            }
        };
        fetchDates();
    }, [userData.mentorId]);

    const generateDefaultDates = (existingDates) => {
        const defaultDates = [];
        const existingDateSet = new Set(existingDates.map((d) => d.date));
        const today = new Date();

        for (let i = 0; i < 30; i++) {
            const date = new Date(today);
            date.setDate(today.getDate() + i);
            const dateString = date.toISOString().split("T")[0];

            if (!existingDateSet.has(dateString)) {
                defaultDates.push({
                    date: dateString,
                    time: "17:00",
                    isAvailable: true,
                });
            }
        }

        return defaultDates;
    };

    const handleDateSelection = (date, timeIds) => {
        setSelectedDates((prev) =>
            prev.includes(date)
                ? prev.filter((d) => d !== date)
                : [...prev, date]
        );

        setSelectedTimeIds((prev) => {
            if (prev.some((id) => timeIds.includes(id))) {
                return prev.filter((id) => !timeIds.includes(id));
            } else {
                return [...prev, ...timeIds];
            }
        });
    };

    const handleAddTime = async (date, time) => {
        if (time) {
            const time24 = convertTo24HourFormat(time);
            try {
                await axios.post(`${BASE_URL}/mentor/addTimeToDate.php`, {
                    mentorId: userData.mentorId,
                    date: date,
                    time: time24,
                });
                const response = await axios.post(`${BASE_URL}/mentor/getMentorDates.php`, {
                    mentorId: userData.mentorId,
                });
                let fetchedDates = response.data;

                // Get current date in IST
                const now = new Date();
                const istOffset = 5.5 * 60 * 60 * 1000; // IST is UTC +5:30
                const nowIST = new Date(now.getTime() + istOffset);

                // Calculate the date for the day after tomorrow
                const tomorrow = new Date(nowIST);
                tomorrow.setDate(tomorrow.getDate() + 1);

                // Format to YYYY-MM-DD
                const tomorrowDate = tomorrow.toISOString().split("T")[0];

                // Filter dates starting from the day after tomorrow
                fetchedDates = fetchedDates.filter(dateObj => dateObj.date >= tomorrowDate);

                setDates(fetchedDates);
            } catch (error) {
                console.error("Error adding time:", error);
            }
        }
    };

    const handleAddBulkTime = async () => {
        if (bulkTime && selectedDates.length > 0) {
            for (let date of selectedDates) {
                await handleAddTime(date, bulkTime);
            }
            setBulkTime("");
        }
    };

    const handleDeleteTime = async (id) => {
        if (id) {
            try {
                await axios.post(`${BASE_URL}/mentor/deleteTimeFromDate.php`, { id });
                const response = await axios.post(`${BASE_URL}/mentor/getMentorDates.php`, {
                    mentorId: userData.mentorId,
                });
                let fetchedDates = response.data;

                // Get current date in IST
                const now = new Date();
                const istOffset = 5.5 * 60 * 60 * 1000; // IST is UTC +5:30
                const nowIST = new Date(now.getTime() + istOffset);

                // Calculate the date for the day after tomorrow
                const tomorrow = new Date(nowIST);
                tomorrow.setDate(tomorrow.getDate() + 1);

                // Format to YYYY-MM-DD
                const tomorrowDate = tomorrow.toISOString().split("T")[0];

                // Filter dates starting from the day after tomorrow
                fetchedDates = fetchedDates.filter(dateObj => dateObj.date >= tomorrowDate);

                setDates(fetchedDates);
            } catch (error) {
                console.error("Error deleting time:", error);
            }
        }
    };

    const handleToggleAvailability = async () => {
        if (selectedTimeIds.length > 0) {
            try {
                // Find the times corresponding to selected time IDs
                const updatedDates = dates.filter(date =>
                    date.times.some(timeObj => selectedTimeIds.includes(timeObj.id))
                );

                console.log("Selected Time IDs:", selectedTimeIds);

                // Initialize an empty array for updated availability
                const updatedAvailability = [];

                // Loop through the selected time IDs and map their availability
                selectedTimeIds.forEach(timeId => {
                    // Find the corresponding date for the current timeId
                    const matchingDate = updatedDates.find(date =>
                        date.times.some(timeObj => timeObj.id === timeId)
                    );

                    // If a matching date is found, get its availability status
                    if (matchingDate) {
                        const isAvailable = !matchingDate.isAvailable;
                        updatedAvailability.push(isAvailable);
                    }
                });

                console.log("Updated Availability:", updatedAvailability);

                // Map the updated times and availability to the API call
                await axios.post(`${BASE_URL}/mentor/toggleMentorDatesAvailability.php`, {
                    timeIds: selectedTimeIds,
                    isAvailable: updatedAvailability,
                });

                // Fetch the updated dates from the server
                const response = await axios.post(`${BASE_URL}/mentor/getMentorDates.php`, {
                    mentorId: userData.mentorId,
                });

                let fetchedDates = response.data;

                // Get current date in IST
                const now = new Date();
                const istOffset = 5.5 * 60 * 60 * 1000; // IST is UTC +5:30
                const nowIST = new Date(now.getTime() + istOffset);

                // Calculate the date for the day after tomorrow
                const tomorrow = new Date(nowIST);
                tomorrow.setDate(tomorrow.getDate() + 1);

                // Format to YYYY-MM-DD
                const tomorrowDate = tomorrow.toISOString().split("T")[0];

                // Filter dates starting from the day after tomorrow
                fetchedDates = fetchedDates.filter(dateObj => dateObj.date >= tomorrowDate);

                setDates(fetchedDates);

                // Clear selected dates and time IDs after toggling
                setSelectedDates([]);
                setSelectedTimeIds([]);
            } catch (error) {
                console.error("Error toggling availability:", error);
            }
        }
    };

    const handleTimeInputChange = (date, value) => {
        setTimeInputs((prev) => ({ ...prev, [date]: value })); // Update the timeInput for this specific date
    };

    // Function to convert time to 12-hour format
    const formatTo12Hr = (time) => {
        const [hour, minute] = time.split(":");
        const formattedHour = hour % 12 || 12;
        const period = hour >= 12 ? "PM" : "AM";
        return `${formattedHour}:${minute} ${period}`;
    };

    const convertTo24HourFormat = (time12h) => {
        const [time, modifier] = time12h.split(" ");
        let [hours, minutes] = time.split(":");

        hours = parseInt(hours, 10);

        if (modifier === "PM" && hours !== 12) {
            hours += 12;
        } else if (modifier === "AM" && hours === 12) {
            hours = 0;
        }

        return `${String(hours).padStart(2, '0')}:${minutes.padStart(2, '0')}`;
    };

    const formatToDate = (dateString) => {
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-based
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
    };

    const generateTimeOptions = () => {
        const timeOptions = [];
        const periods = ["AM", "PM"];

        for (const period of periods) {
            for (let hour = 0; hour < 12; hour++) {
                const displayHour = hour === 0 ? 12 : hour; // Convert 0 to 12 for AM/PM format
                for (let min = 0; min < 60; min += 15) {
                    const formattedTime = `${displayHour}:${min === 0 ? "00" : min} ${period}`;
                    timeOptions.push(formattedTime);
                }
            }
        }
        return timeOptions;
    };

    return (
        <div className="mentor-availability-container">
            <h2>Manage Availability</h2>
            <div className="bulk-actions">
                <button onClick={handleToggleAvailability} disabled={selectedDates.length === 0}>
                    Change Availability
                </button>
                <div>
                    <select value={bulkTime} onChange={(e) => setBulkTime(e.target.value)}>
                        <option value="">Select Time</option>
                        {generateTimeOptions().map((time) => (
                            <option key={time} value={time}>{time}</option>
                        ))}
                    </select>
                    <button onClick={handleAddBulkTime} disabled={selectedDates.length === 0}>
                        Add Time to Selected Dates
                    </button>
                </div>
            </div>
            <div className="mentor-availability-box">
                <div className="dates-list">
                    {dates.map((date) => (
                        <div key={date.date} className={`date-card ${selectedDates.includes(date.date) ? "selected" : ""}`}>
                            <label>
                                <input
                                    type="checkbox"
                                    checked={selectedDates.includes(date.date)}
                                    onChange={() => handleDateSelection(date.date, date.times.map((t) => t.id))}
                                />
                                {formatToDate(date.date)}
                            </label>
                            <div className="times-list">
                                {date.times.map((timeObj) => (
                                    <div key={timeObj.id} className="time-item">
                                        {formatTo12Hr(timeObj.time)} {/* Already in 12hr format if needed */}
                                        <button onClick={() => { handleDeleteTime(timeObj.id) }}>x</button>
                                    </div>
                                ))}
                            </div>
                            <div className="availability-status">
                                {date.isAvailable ? "Available" : "Unavailable"}
                            </div>
                            <div className="add-time-section">
                                <select value={timeInputs[date.date] || ""} onChange={(e) => setTimeInputs(prev => ({ ...prev, [date.date]: e.target.value }))}>
                                    <option value="">Select Time</option>
                                    {generateTimeOptions().map((time) => (
                                        <option key={time} value={time}>{time}</option>
                                    ))}
                                </select>
                                <button onClick={() => handleAddTime(date.date, timeInputs[date.date])}>+</button>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}

export default MentorAvailability;
